




















































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { Group } from "@/services/Group";
import { VehicleType } from "@/services/VehicleType";

@Component
export default class GroupsDetails extends Vue {
  @Prop({ type: String, required: false })
  idGroup;
  @Prop({ type: Array, required: true })
  itemList: [];
  @Prop({ type: Boolean, required: true })
  addMode;
  @Prop({ type: Boolean, required: true })
  firstSearch;
  loading: boolean = false;
  group: Group = new Group("", null, "", null);
  itemSelected: VehicleType[] = [];
  isSaveClicked: boolean = false;

  async addOrUpdate(group: Group) {
     this.isSaveClicked = true;
    if (group.description.length === 0)
      General.showAlertDanger("Please Enter a description", this);
    else {
      this.setItemList(group, this.itemSelected);

      if (this.addMode) 
        await this.addGroupDo(group);
       else 
       this.updateGroupDo(group);

      this.isSaveClicked = false;
    }
  }

  async updateGroupDo(group:Group){

    General.confirm(
      "Do you want update group with code:" + group.groupCode + "?",
      this,
      async () => {
         await this.updateGroup(group);
        this.closeDetailModal();
        if (this.firstSearch) this.$emit("groups-Search");
      }
    );
  }

  async addGroupDo(group:Group){
    General.confirm(
      "Do you want add this group?",
      this,
      async () => {     
       await this.addGroup(group);
        this.closeAddModal();
        if (this.firstSearch) this.$emit("groups-Search");
      }
    );
  }

  async addGroup(group: Group) {
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/AddGroup"),
        data: {
          description: group.description,
          vehicleTypes: group.vehicleTypes,
        },
        withCredentials: true,
        responseType: "json",
      });
      General.showAlertSuccess("Group successfully added", this);
    } catch (error) {
      General.HandleError(error, this);
    } finally{
      this.loading = false;
    }
  }

  async deleteGroupDo(group: Group) {
    General.confirm(
      "Do you want delete the group:" + group.description + "?",
      this,
      async () => {
        await this.deleteGroup(group.idGroup);
        this.closeDetailModal();
        this.$router.push("/groups");
        this.$emit("groups-Search");
      }
    );
  }

    returnState(condiction:boolean,clickButton:boolean) : boolean{
       if(clickButton)
           return condiction  
       else return null;
    }

  async deleteGroup(idGroupToDelete: string) {
    this.loading = true;
    try {
      await axios.delete(
        General.GetApiUrl(
          "/api/lubricationTable/DeleteGroup?idGroup=" + idGroupToDelete
        ),
        { withCredentials: true }
      );
      General.showAlertSuccess("Group successfully removed", this);
    } catch (ex) {
      General.HandleError(ex, this);
    } finally {
      this.loading = false;
    }
  }
  async updateGroup(group: Group) {
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/UpdateGroup"),
        data: {
          idGroup: group.idGroup,
          description: group.description,
          groupCode: group.groupCode,
          vehicleTypes: group.vehicleTypes,
        },
        withCredentials: true,
        responseType: "json",
      });
    } catch (error) {
      General.HandleError(error, this);
    } finally{
      this.loading = false;
    }
  }

  getTypes(vehicleTypes: Array<VehicleType>): string {
    let stringa = "";
    vehicleTypes.forEach(function (el) {
      if (vehicleTypes.indexOf(el) != vehicleTypes.length - 1)
        stringa += el.type + ",";
      else stringa += el.type;
    });
    return stringa;
  }

  async mounted() {
    if (!this.addMode) {
      this.loading = true;
      await this.getGroup(this.idGroup);
      this.setItemSelected(this.group.vehicleTypes);
    }
  }

  setItemList(group: Group, vehicleTypes: VehicleType[]) {
    group.vehicleTypes = [...vehicleTypes];
  }

  setItemSelected(vehicleTypes: VehicleType[]) {
    this.itemSelected = [...vehicleTypes];
  }
  async getGroup(idGroup: string) {
    try {
      let group = await axios.get<Group>(
        General.GetApiUrl("/api/lubricationTable/GetGroup?idGroup=" + idGroup),
        {
          withCredentials: true,
          responseType: "json",
        }
      );
      this.group = group.data;
    } catch (ex) {
      General.HandleError(ex, this);
    } finally {
      this.loading = false;
    }
  }

  closeDetailModal() {
    this.$bvModal.hide("group-detail-modal");
  }
  closeAddModal() {
    this.$bvModal.hide("group-add-modal");
  }

  canManageLubTable() {
    return General.CanManageLubTable();
  }
}
